import { plugin, debug } from 'light-component';
import * as Base from '@base';
import { t } from '@common';
import { Require } from '../component';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { NumberProps } from './types';

export function WidgetNumber(props: NumberProps): ReactElement {
  debug.widget('form number', props);
  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <div className={styles.input}>
        <Base.InputNumber
          step={props.step ?? 1}
          className={styles.select}
          placeholder={t(props.textPlaceholder ?? '')}
          disabled={props.readonly}
          value={props.value}
          status={props?.focus === props.name ? 'error' : undefined}
          onDrop={event => event.preventDefault()}
          onChange={value => props.onChange?.(value)}
          min={props.min}
          max={props.max}
        />
      </div>
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'number', component: WidgetNumber });

